module.exports = "/_next/static/images/networkOperationCentre-3fa9262e5d1afd85c682f136f36120f1.webp";